import { render, staticRenderFns } from "./Workaddres.vue?vue&type=template&id=2675f68c&scoped=true"
import script from "./Workaddres.vue?vue&type=script&lang=js"
export * from "./Workaddres.vue?vue&type=script&lang=js"
import style0 from "./Workaddres.vue?vue&type=style&index=0&id=2675f68c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2675f68c",
  null
  
)

export default component.exports